<template>
  <div class="d-flex align-items-center justify-content-between mt-2">
    <!-- Left: Per page select -->
    <memlist-select-input2
      v-model="per_page"
      :items="per_page_options"
      :show_none="false"
      class="mr-2"
      style="width: 100px; height: 35px;"
      @input="on_per_page_changed"
    />

    <!-- Right: Pagination -->
    <ul class="pagination mb-0" style="padding-left: 0px !important;">
      <li class="page-item" :class="{ disabled: current_page === 1 }">
        <a class="page-link" href="#" @click.prevent="change_page(1)">«</a>
      </li>
      <li class="page-item" :class="{ disabled: current_page === 1 }">
        <a class="page-link" href="#" @click.prevent="change_page(current_page - 1)">‹</a>
      </li>

      <li
        class="page-item"
        v-for="p in visible_pages"
        :key="p"
        :class="{ active: p === current_page }"
      >
        <a class="page-link" href="#" @click.prevent="change_page(p)">{{ p }}</a>
      </li>

      <li class="page-item" :class="{ disabled: current_page === total_pages }">
        <a class="page-link" href="#" @click.prevent="change_page(current_page + 1)">›</a>
      </li>
      <li class="page-item" :class="{ disabled: current_page === total_pages }">
        <a class="page-link" href="#" @click.prevent="change_page(total_pages)">»</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MemlistPagination',
  props: {
    total_rows: Number,
    per_page: {
      type: Number,
      default: 100
    },
  },
  data() {
    return {
      current_page: 1,
    }
  },
  computed: {
    total_pages() {
      return Math.max(1, Math.ceil(this.total_rows / this.per_page))
    },
    visible_pages() {
      const pages = []
      const max = this.total_pages
      let start = Math.max(this.current_page - 2, 1)
      let end = Math.min(start + 4, max)
      if (end - start < 4) start = Math.max(end - 4, 1)
      for (let i = start; i <= end; i++) pages.push(i)
      return pages
    },
    per_page_options() {
      return [100, 250, 500].map(v => ({ value: v, text: v.toString() }))
    },
  },
  watch: {
    total_rows() {
      if (this.current_page > this.total_pages) {
        this.current_page = this.total_pages
        this.emit_page()
      }
    }
  },
  methods: {
    change_page(p) {
      if (p < 1 || p > this.total_pages || p === this.current_page) return
      this.current_page = p
      this.emit_page()
    },
    emit_page() {
      this.$emit('page-changed', this.current_page)
    },
    on_per_page_changed(val) {
      this.$emit('per-page-changed', val)
      this.current_page = 1
      this.emit_page()
    },
  },
}
</script>
